import React from 'react';
import { Card, Skeleton, Statistic } from 'antd';

import styles from './AIClipperMetrics.module.scss';

interface KpiCardProps {
  title: string;
  value: number;
  loading: boolean;
  variantClass?: string;
  active?: boolean;
  onClick?: () => void;
}

const KpiCard: React.FC<KpiCardProps> = React.memo(function KpiCard({
  title,
  value,
  loading,
  variantClass,
  active = false,
  onClick,
}) {
  const clickable = typeof onClick === 'function';
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };
  return (
    <Card
      className={[
        styles.kpiCard,
        variantClass || '',
        clickable ? styles.kpiClickable : '',
        clickable && active ? styles.kpiActive : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      onKeyDown={clickable ? onKeyDown : undefined}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : undefined}
      aria-pressed={clickable ? active : undefined}
    >
      {loading ? (
        <Skeleton active paragraph={false} title={{ width: '60%' }} />
      ) : (
        <Statistic title={title} value={value} />
      )}
    </Card>
  );
});

export default KpiCard;
